import React from "react";
import { Check } from "react-feather";

import './stylesCheckBox.css'

const CheckBox = ({
    height, 
    width,
    border_radius,
    isSelected, 
    onClicked
}) => {

    const handleClicked = () => {
        onClicked()
    }

    return (
        <button 
            style={{
                height: height, 
                width: width,
                borderRadius: border_radius,
                outline: "none",
                border: "solid",
                backgroundColor: isSelected ? "var(--COLOR-INACTIVE_BUTTON_BACKGROUND)" : 'transparent',
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderColor: isSelected ? "var(--COLOR-PRIMARY)" : "var(--COLOR-DEFAULT_BORDER_GRADIENT_0)"
             }}
             onClick={handleClicked}
             type="button"
        >

             {
                isSelected 
                ?  (
                <Check 
                className="check-icon"
                />
                )
                : null
            }

        </button>
    );
}

export default CheckBox;